import "./index.css";

import * as Sentry from "@sentry/solid";
import { Route, Router } from "@solidjs/router";
import { initializeApp } from "firebase/app";
import { lazy } from "solid-js";
import { render } from "solid-js/web";
import { getAllTopics, getTopic } from "./utility/getTopics";
import { watchStorageConnection } from "./utility/storage";

import { SignInProvider } from "./components/SignInContext";

Sentry.init({
  dsn: "https://f7543e91f7ddfd3141ed13faea4801f1@o4509885521330176.ingest.us.sentry.io/4509885522640896",
  sendDefaultPii: true,
});

const firebaseConfig = {
  apiKey: "AIzaSyDDz690srkGOWLbWXuGYeQCGm2vYuKL35A",
  authDomain: "checkit.gg",
  projectId: "checkit-ac32f",
  storageBucket: "checkit-ac32f.firebasestorage.app",
  messagingSenderId: "717347341482",
  appId: "1:717347341482:web:1cc11e7c4b90391553fcd3",
  measurementId: "G-9F2MBBN0Z9",
};

initializeApp(firebaseConfig);

watchStorageConnection();

const Admin = lazy(() => import("./pages/Admin"));
const App = lazy(() => import("./pages/App"));
const Edit = lazy(() => import("./pages/Edit"));
const Home = lazy(() => import("./pages/Home"));
const All = lazy(() => import("./pages/All"));
const About = lazy(() => import("./pages/About"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));

render(
  () => (
    <SignInProvider>
      <Router>
        <Route path="/" component={Home} />
        <Route path="/admin" component={Admin} />
        <Route path="/all" component={All} preload={() => getAllTopics()} />
        <Route path="/about" component={About} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/terms" component={Terms} />
        <Route
          path="/:topic"
          component={App}
          preload={({ params }) => getTopic(decodeURIComponent(params.topic))}
        />
        <Route path="/:topic/edit" component={Edit} />
      </Router>
    </SignInProvider>
  ),
  document.body,
);
